var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareOnDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.73 110.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.73,
    y: 0,
    width: 0,
    height: 33.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.65,11.08v-5.54c0-3.06-2.48-5.53-5.54-5.54h-33.23c-3.05.01-5.53,2.48-5.54,5.54v22.15c.01,3.05,2.48,5.53,5.54,5.54h33.23c3.06-.01,5.53-2.49,5.54-5.54v-5.54l11.08,11.08V0l-11.08,11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.66,44.31h-38.77c-9.17,0-16.61-7.44-16.62-16.62V11.08H27.5c-9.18,0-16.62,7.44-16.62,16.61h0v55.39h110.77v-38.77ZM44.11,22.15h0c6.12,0,11.08,4.96,11.08,11.07,0,6.12-4.96,11.08-11.07,11.08-6.12,0-11.08-4.96-11.08-11.07,0-6.12,4.95-11.08,11.07-11.08Zm-22.15,49.85c0-9.17,7.44-16.61,16.62-16.61h11.08c9.17,0,16.61,7.43,16.62,16.61H21.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.89,99.7h-33.23l-5.54-5.54H0c.76,9.09,8.25,16.33,17.56,16.58h97.55c9.31-.25,16.8-7.49,17.56-16.58h-44.24l-5.54,5.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareOnDemand);
export default __webpack_public_path__ + "static/media/Care-on-demand.b0c2965255f631df70df7a437b79d1de.svg";
export { ForwardRef as ReactComponent };